export default "__VITE_ASSET__57266bbe__"